"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Kaeriten = {
    elemName: '返り点',
    type: 'inline',
    doc: '漢文の送り仮名をマークアップします。',
    example: '｛＿レ｝',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '＿{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Kaeriten {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<span type="kaeriten" {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</span>`,
    docxTemplate: `
			<w:r>
        		<w:rPr>
                    <w:rFonts w:hint="eastAsia"/>
                    <w:vertAlign w:val="subscript"/>
                </w:rPr>
                <w:t>{{{$$1}}}</w:t>
            </w:r>
	`,
    latexTemplate: '\\kaeriten{ {{{$1}}} }'
};
exports.default = Kaeriten;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS2Flcml0ZW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9LYWVyaXRlbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLE1BQU0sUUFBUSxHQUFtQjtJQUNoQyxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLG9CQUFvQjtJQUN6QixPQUFPLEVBQUUsTUFBTTtJQUNmLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLFlBQVksRUFBRSxTQUFTO0lBQ3ZCLFlBQVksRUFBRSxtRUFBbUU7SUFDakYsV0FBVyxFQUFFLHVFQUF1RTtJQUNwRixZQUFZLEVBQUU7Ozs7Ozs7O0VBUWI7SUFDRCxhQUFhLEVBQUUsd0JBQXdCO0NBRXZDLENBQUM7QUFFRixrQkFBZSxRQUFRLENBQUMifQ==